/**
 * ひな形限定選択肢用のTanStack Query キーファクトリー
 *
 * queryKeyにsessionIdまたはtemplateIdを含めることで、
 * 異なるひな形編集セッション間でキャッシュが分離される
 */
export const templateSpecificMultipleChoicesQueryKeys = {
  /**
   * 新規作成時のキー（sessionIdで分離）
   */
  bySession: (sessionId: string) =>
    ['templateSpecificMultipleChoices', 'session', sessionId] as const,

  /**
   * 編集時のキー（templateIdで分離）
   */
  byTemplateId: (templateId: number) =>
    ['templateSpecificMultipleChoices', 'template', templateId] as const,
} as const
